import { render, staticRenderFns } from "./ChatFaceDialog.vue?vue&type=template&id=71a5ca1b&lang=pug&"
import script from "./ChatFaceDialog.vue?vue&type=script&lang=ts&"
export * from "./ChatFaceDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChatFaceDialog.vue"
export default component.exports